import { useUIStore } from '@/store/uiStore';
import { usePlayer } from '@/api/queries';
import { useAuthStore } from '@/store/authStore';
import { imageUrl } from '@/api/client';

export function AvatarOverlay() {
  const isOpen = useUIStore((s) => s.isModalOpen('avatar'));
  const closeModal = useUIStore((s) => s.closeModal);
  const userId = useAuthStore((s) => s.userId);
  const { data } = usePlayer(userId, isOpen);
  const player = data?.player;

  if (!isOpen || !player) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in"
      onClick={() => closeModal('avatar')}
    >
      <div className="max-w-xs w-full space-y-4 text-center">
        {player.avatar_url && (
          <img
            src={imageUrl(player.avatar_url) ?? ''}
            alt={player.character_name}
            className="w-full rounded-2xl shadow-glow"
          />
        )}
        <div>
          <div className="font-display text-2xl text-white">{player.character_name}</div>
          <div className="text-white/50 text-sm">Lv. {player.level} · Grade {player.current_grade}</div>
        </div>
      </div>
    </div>
  );
}
